import sanitiseEstimateItem from '../../../Services/sanitiseEstimateItem';

export default ({ estimateGroupIndex, estimateItemIndex }) => async (dispatch) => dispatch(sanitiseEstimateItem({ estimateGroupIndex, estimateItemIndex }));